import styled from "styled-components/macro";
import { BALLOON_MAX_SCALE } from "./useStandaloneFetalSexBalloonPress";

// The balloon is laid out at its fully-inflated size and scaled down to this
// resting size, so the SVG stays sharp when the balloon blows up.
const BALLOON_RESTING_REM = 3.5;
const BALLOON_INFLATED_REM = BALLOON_RESTING_REM * BALLOON_MAX_SCALE;

export const StandaloneFetalSexCardContainer = styled.div`
  background-color: ${({ theme }) => theme.white};
  border-radius: 1.5rem;
  box-shadow: ${({ theme }) => theme.boxShadow};
  box-sizing: border-box;
  display: grid;
  gap: 1rem;
  isolation: isolate;
  margin-top: 1.25rem;
  max-width: 50.125rem;
  min-width: 0;
  overflow: hidden;
  padding: 1rem 1.25rem 1.25rem;
  position: relative;
  width: 100%;
`;

export const StandaloneFetalSexCardTitle = styled.div`
  align-items: center;
  display: flex;
  justify-content: space-between;
  position: relative;
  text-transform: uppercase;
  z-index: 1;

  p {
    font-size: 20px;
  }
`;

export const StandaloneFetalSexProcessingStatus = styled.div`
  align-items: center;
  display: inline-flex;
  gap: 0.25rem;
  min-width: 0;

  svg {
    display: block;
  }
`;

export const StandaloneFetalSexBalloonStage = styled.div`
  align-items: center;
  display: grid;
  gap: 0.5rem;
  justify-items: center;
  padding: 0.25rem 0 0.5rem;
  user-select: none;
  -webkit-touch-callout: none;
  -webkit-user-select: none;
`;

export const StandaloneFetalSexBalloonButton = styled.button`
  align-items: center;
  background: transparent;
  border: 0;
  border-radius: 50%;
  cursor: pointer;
  display: inline-flex;
  height: 5.5rem;
  justify-content: center;
  padding: 0;
  touch-action: none;
  user-select: none;
  width: 5.5rem;
  -webkit-tap-highlight-color: transparent;
  -webkit-touch-callout: none;
  -webkit-user-select: none;

  &:focus-visible {
    outline: 0.1875rem solid ${({ theme }) => theme.greenMedium};
    outline-offset: 0.25rem;
  }

  &:disabled {
    cursor: wait;
  }
`;

export const StandaloneFetalSexBalloonMotion = styled.span`
  align-items: center;
  display: inline-flex;
  flex: none;
  height: ${BALLOON_INFLATED_REM}rem;
  justify-content: center;
  pointer-events: none;
  position: relative;
  transform: scale(${1 / BALLOON_MAX_SCALE});
  transform-origin: center;
  width: ${BALLOON_INFLATED_REM}rem;
  will-change: transform;
  z-index: 2;
`;

export const StandaloneFetalSexBalloonIconSvg = styled.svg`
  color: ${({ theme }) => theme.redMedium};
  height: ${BALLOON_INFLATED_REM}rem;
  overflow: visible;
  pointer-events: none;
  width: ${BALLOON_INFLATED_REM}rem;
`;

export const StandaloneFetalSexHoldInstruction = styled.div`
  max-width: 28rem;
  text-align: center;
`;

export const StandaloneFetalSexRevealedStage = styled.div`
  display: grid;
  position: relative;
  z-index: 1;
`;

export const StandaloneFetalSexUndoButton = styled.button`
  align-items: center;
  background: transparent;
  border: 0;
  border-radius: 22.5px;
  color: ${({ theme }) => theme.redMedium};
  cursor: pointer;
  display: inline-flex;
  font-size: 15px;
  height: 45px;
  justify-content: center;
  justify-self: end;
  padding: 0 1rem;
  position: relative;
  z-index: 1;

  :hover {
    background-color: ${({ theme }) => theme.redPastel};
  }
`;

export const StandaloneFetalSexDivider = styled.div`
  background-color: ${({ theme }) => theme.neutral100};
  height: 1px;
  margin: 0 32px;
  position: relative;
  z-index: 1;
`;

export const StandaloneFetalSexShareSection = styled.div`
  display: grid;
  gap: 0.75rem;
  justify-items: center;
  padding: 0.25rem 0 0.5rem;
  position: relative;
  z-index: 1;
`;

export const StandaloneFetalSexShareButton = styled.button`
  align-items: center;
  background-color: ${({ theme }) => theme.white};
  border: 2px solid ${({ theme }) => theme.redMedium};
  border-radius: 22.5px;
  box-sizing: border-box;
  color: ${({ theme }) => theme.redMedium};
  cursor: pointer;
  display: inline-flex;
  font-family: bold;
  font-size: 21px;
  font-weight: 700;
  gap: 0.5rem;
  height: 45px;
  justify-content: center;
  letter-spacing: 0.42px;
  line-height: 20px;
  padding: 0 1.5rem;
  text-transform: uppercase;

  svg {
    font-size: 15px;
  }

  :hover {
    background-color: ${({ theme }) => theme.redPastel};
  }
`;

export const StandaloneFetalSexShareCaption = styled.div`
  max-width: 17.5rem;
  text-align: center;
`;
